/* eslint-disable @typescript-eslint/no-magic-numbers */
import { IsInt, IsOptional, IsString, MaxLength } from "class-validator";

import "reflect-metadata";

export class PermissionDto {
  id: number;

  @IsInt()
  entityId: number;

  @IsString()
  @MaxLength(255)
  action: string;

  @IsString()
  @IsOptional()
  @MaxLength(255)
  description?: string;
}
